<template>
  <div class="ren-decoration-cp ren-decoration-cp-content-video-player">
    <video v-if="videoUrl" :src="videoUrl" :poster="posterUrl || undefined" :controls="showControls" preload="metadata" />
    <span v-else>短视频播放器</span>
    <small v-if="showCaption && caption">{{ caption }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const videoUrl = computed(() => widgetMediaUrl(data.value.videoUrl ?? data.value.url))
const posterUrl = computed(() => widgetMediaUrl(data.value.posterUrl ?? data.value.coverUrl))
const showControls = computed(() => booleanValue(props.component.props?.showControls, true))
const showCaption = computed(() => booleanValue(props.component.props?.showCaption, true))
const caption = computed(() => stringValue(data.value.title ?? data.value.caption))
</script>

<style scoped>
.ren-decoration-cp-content-video-player {
  display: grid;
  place-items: center;
  min-height: 160px;
  background: var(--ren-theme-background);
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-content-video-player video {
  width: 100%;
  height: auto;
}
</style>
